var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7631 0.645996C27.6177 0.645996 28.4373 0.985479 29.0416 1.58976C29.6459 2.19405 29.9854 3.01363 29.9854 3.86822V26.4238C29.9854 27.2784 29.6459 28.0979 29.0416 28.7022C28.4373 29.3065 27.6177 29.646 26.7631 29.646H4.20757C3.35299 29.646 2.5334 29.3065 1.92912 28.7022C1.32483 28.0979 0.985352 27.2784 0.985352 26.4238V3.86822C0.985352 3.01363 1.32483 2.19405 1.92912 1.58976C2.5334 0.985479 3.35299 0.645996 4.20757 0.645996H26.7631ZM25.9576 25.6182V17.0793C25.9576 15.6864 25.4042 14.3504 24.4192 13.3654C23.4343 12.3805 22.0983 11.8271 20.7054 11.8271C19.3359 11.8271 17.7409 12.6649 16.9676 13.9216V12.1332H12.4726V25.6182H16.9676V17.6754C16.9676 16.4349 17.9665 15.4199 19.207 15.4199C19.8052 15.4199 20.3789 15.6575 20.8019 16.0805C21.2249 16.5035 21.4626 17.0772 21.4626 17.6754V25.6182H25.9576ZM7.23646 9.60378C7.95432 9.60378 8.64277 9.31861 9.15037 8.81101C9.65796 8.30341 9.94313 7.61496 9.94313 6.89711C9.94313 5.39877 8.7348 4.17433 7.23646 4.17433C6.51434 4.17433 5.82179 4.46119 5.31117 4.97181C4.80055 5.48243 4.51368 6.17498 4.51368 6.89711C4.51368 8.39544 5.73813 9.60378 7.23646 9.60378ZM9.47591 25.6182V12.1332H5.01313V25.6182H9.47591Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.7e1040a8bb3fc85b0c1a23dbc107dd32.svg";
export { ForwardRef as ReactComponent };